/**
 * SCRUM-435/440 — qué permisos operativos requieren un product flag específico
 * habilitado para tener efecto real. Deliberadamente conservador: solo incluye
 * los casos donde existe un flag real y verificable (feature add-on, no core
 * del producto) — la mayoría de los 18 permisos (catálogo, pedidos, clientes,
 * sucursales, configuración) son base del producto y NO tienen entrada acá,
 * porque todo tenant los tiene disponibles sin importar el plan.
 *
 * Inventar una relación permiso↔flag sin evidencia real ocultaría permisos
 * legítimos a un tenant que sí los tiene habilitados — por eso esta lista es
 * corta y solo cubre relaciones verificables contra tenant-product-flags.ts.
 */
import type { OperationalPermission } from "./operational-permissions";

export const PERMISSION_REQUIRED_FLAG: Partial<Record<OperationalPermission, string>> = {
  can_manage_tables: "dine_in_tables",
  can_confirm_booking: "booking_widget",
  can_manage_schedule: "booking_widget",
  can_send_campaigns: "growth_campaigns",
};

/** ¿Este permiso tiene efecto real para el tenant, dados sus product flags? */
export function isPermissionUsable(
  permission: OperationalPermission,
  productFlags: Record<string, boolean> | undefined,
): boolean {
  const requiredFlag = PERMISSION_REQUIRED_FLAG[permission];
  if (!requiredFlag) return true; // sin requisito conocido = permiso core, siempre usable
  if (!productFlags) return true; // flags aún no cargados — no ocultar de más mientras carga
  return productFlags[requiredFlag] === true;
}
